let lockedTop = null;
let lockedLeft = null;

function preventScroll(e) {
  if (e.cancelable) {
    e.preventDefault();
  }
  window.scrollTo(lockedLeft, lockedTop);
}

function lockBodyOverflow() {
  lockedTop = window.pageYOffset;
  lockedLeft = window.pageXOffset;
  window.addEventListener('touchmove', preventScroll, { passive: false });
  window.addEventListener('wheel', preventScroll, { passive: false });
  window.addEventListener('mousewheel', preventScroll, { passive: false });
  window.addEventListener('DOMMouseScroll', preventScroll, { passive: false });
  document.body.classList.add('locked');
}

function restoreBodyOverflow() {
  lockedTop = null;
  lockedLeft = null;
  window.removeEventListener('touchmove', preventScroll, { passive: false });
  window.removeEventListener('wheel', preventScroll, { passive: false });
  window.removeEventListener('mousewheel', preventScroll, { passive: false });
  window.removeEventListener('DOMMouseScroll', preventScroll, { passive: false });
  document.body.classList.remove('locked');
}

export default {
  lockBodyOverflow,
  restoreBodyOverflow
};

export {
  lockBodyOverflow,
  restoreBodyOverflow
};
